<template lang="pug">
  .div
    .columns
      h1.is-size-4
          strong  Permisos
    .columns
      .column
        .field
          label.label Combustible
          .control.has-icons-left
            .select.is-primary.is-rounded
              select(v-model="p_comb")
                option(v-for="p in permisos.permisos_combustibles" :value="p.id") {{ p.permisos }}
    .columns
      .column
        .field
          label.label Inventarios
          .control.has-icons-left
            .select.is-primary.is-rounded
              select(v-model="p_inv")
                option(v-for="p in permisos.permisos_inventarios" :value="p.id") {{ p.permisos }}
    .columns
      .column
        .field
          label.label Monitoreo
          .control.has-icons-left
            .select.is-primary.is-rounded
              select(v-model="p_mon")
                option(v-for="p in permisos.permisos_monitoreo" :value="p.id") {{ p.permisos }}
    .columns
      .column
        .field
          label.label Reportes
          .control.has-icons-left
            .select.is-primary.is-rounded
              select(v-model="p_rep")
                option(v-for="p in permisos.permisos_reportes" :value="p.id") {{ p.permisos }}
    .columns
      .column
        .field
          label.label Requisiciones
          .control.has-icons-left
            .select.is-primary.is-rounded
              select(v-model="p_req")
                option(v-for="p in permisos.permisos_requisiciones" :value="p.id") {{ p.permisos }}
    .columns
      .column
        .field
          label.label Responsivas
          .control.has-icons-left
            .select.is-primary.is-rounded
              select(v-model="p_resp")
                option(v-for="p in permisos.permisos_responsivas" :value="p.id") {{ p.permisos }}
    .columns
      .column
        .field
          label.label SCA TPA
          .control.has-icons-left
            .select.is-primary.is-rounded
              select(v-model="p_scaT")
                option(v-for="p in permisos.permisos_sca_tpa" :value="p.id") {{ p.permisos }}
    .columns
      .column
        .field
          label.label SCA IRGE
          .control.has-icons-left
            .select.is-primary.is-rounded
              select(v-model="p_scaI")
                option(v-for="p in permisos.permisos_sca_irge" :value="p.id") {{ p.permisos }}
    .columns
      .column
        .field
          label.label Tags
          .control.has-icons-left
            .select.is-primary.is-rounded
              select(v-model="p_tag")
                option(v-for="p in permisos.permisos_tags" :value="p.id") {{ p.permisos }}
    .columns
      .column
        .field
          label.label Tarjetas
          .control.has-icons-left
            .select.is-primary.is-rounded
              select(v-model="p_tar")
                option(v-for="p in permisos.permisos_tarjetas" :value="p.id") {{ p.permisos }}
    .columns
      .column
        .field
          label.label Vehiculos
          .control.has-icons-left
            .select.is-primary.is-rounded
              select(v-model="p_veh")
                option(v-for="p in permisos.permisos_vehiculos" :value="p.id") {{ p.permisos }}
    .columns
      .column
        .field
          label.label Facturas
          .control.has-icons-left
            .select.is-primary.is-rounded
              select(v-model="p_veh")
                option(v-for="p in permisos.permisos_facturas" :value="p.id") {{ p.permisos }}
    .columns
      .column
        .field
          label.label Visitas
          .control.has-icons-left
            .select.is-primary.is-rounded
              select(v-model="p_veh")
                option(v-for="p in permisos.permisos_visitas" :value="p.id") {{ p.permisos }}
</template>

<script>
  export default {
    name: 'FormPermiso',
    props: {
      permisos: {
        type: Object,
        default: () => {}
      },
    },
    data() {
      return {
        p_comb: {},
        p_inv: {},
        p_mon: {},
        p_rep: {},
        p_req: {},
        p_resp: {},
        p_scaT: {},
        p_scaI: {},
        p_tag: {},
        p_tar: {},
        p_veh: {},
        p_fact: {},
        p_vis: {},
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/usuarios_Componentes/componentes/FormPermisos.vue